import { TableLeft, TableRight } from "../../assets/svg";

const Pagination = ({ total, lastPage, current, pagination }) => {
  const handlePagination = (newPage) => {
    pagination(newPage);
  };

  const isNextDisabled = current === lastPage;
  const isPrevDisabled = current === 1;

  return (
    <div className="flex justify-center items-center">
      <ul className="flex items-center gap-2 sm:gap-4 p-1.5">
        {/* Previous Button */}
        <li className="page-item">
          <button
            className={`flex items-center justify-center rounded-full p-2 ${
              isPrevDisabled
                ? "cursor-not-allowed opacity-50"
                : "cursor-pointer"
            }`}
            onClick={() => !isPrevDisabled && handlePagination(current - 1)}
            disabled={isPrevDisabled}
          >
            <TableLeft size="20" className="text-gray-600 w-5 h-5" />
          </button>
        </li>

        {/* Next Button */}
        <li className="page-item">
          <button
            className={`flex items-center justify-center rounded-full p-2 ${
              isNextDisabled
                ? "cursor-not-allowed opacity-50"
                : "cursor-pointer"
            }`}
            onClick={() => !isNextDisabled && handlePagination(current + 1)}
            disabled={isNextDisabled}
          >
            <TableRight size="20" className="text-gray-600 w-5 h-5" />
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
